export function acWidgetToggle(val) {
    return function (dispatch) {
        if (val) {
            dispatch({ type: 'MOB_TOGGLE', payload: false })
        }
        dispatch({ type: 'WIDGET_TOGGLE', payload: val })
    }
}